import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../../shared/components/base/base.component';
import { TitleService } from '../../shared/services/title.service';
import { Router } from '@angular/router';
import { MatIconButtonComponent } from '../../shared/components/mat-icon-button/mat-icon-button.component';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconButtonComponent],
})
export class NotFoundComponent extends BaseComponent implements OnInit {
  currentUrl?: string;

  constructor(
    private router: Router,
    private titleService: TitleService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.titleService.setTitle(`404 - Seite nicht gefunden`);
    this.currentUrl = this.router.url;
  }
}
